// extracted by mini-css-extract-plugin
export default {"card":"R0-z","carouselContainer":"S0-z","carouselContent":"T0-z"};